import { RiderScheduleSlot } from "./rider-schedule"

export const RIDER_TYPE = { STAFF: "staff", THIRD_PARTY: "third_party", WAREHOUSE: "warehouse" } as const
export type RiderType = (typeof RIDER_TYPE)[keyof typeof RIDER_TYPE]

export const RIDER_TYPE_LABEL: Record<RiderType, string> = {
  [RIDER_TYPE.STAFF]: "Personal propio",
  [RIDER_TYPE.THIRD_PARTY]: "Tercero",
  [RIDER_TYPE.WAREHOUSE]: "Almacén"
}

export interface Rider {
  id: string
  name: string
  type: RiderType
  phone?: string
  vehiclePlate?: string
  notes?: string
  supabaseUserId?: string
  isActive?: boolean
  /** true = existe (historial, mapa) pero no es asignable a puntos, ej. el usuario "Libre" */
  excludeFromDispatch?: boolean
  /** Horario de trabajo (hora de Lima). null/ausente = el de por defecto (lunes a sábado 07:00-22:00); [] = no trabaja */
  schedule?: RiderScheduleSlot[] | null
  /** País donde trabaja: "Perú" | "Ecuador". Sin valor = Perú */
  country?: string
  /** Centro donde trabaja (LIM, TRU, UIO, GYE…). Solo se le asignan puntos de su centro; sin valor no se restringe */
  center?: string | null
  createdAt?: string
  updatedAt?: string
}

export interface SaveRiderDto {
  name?: string
  type?: RiderType
  phone?: string
  vehiclePlate?: string
  notes?: string
  supabaseUserId?: string
  isActive?: boolean
  /** Solo se envía si el horario cambió. null = volver al horario por defecto */
  schedule?: RiderScheduleSlot[] | null
  /** Solo lo manda el admin ("Perú" | "Ecuador"); los demás crean en su país */
  country?: string
  /** Centro donde trabaja. null = quitarlo (sin restricción por centro) */
  center?: string | null
}

export interface QueryRiderParams {
  page?: number
  rows?: number
  sortColumn?: string
  sortDirection?: "asc" | "desc"
  search?: string
  type?: string
  isActive?: boolean
  /** true = solo los asignables a puntos (activos y no excluidos del despacho, ej. sin "Libre") */
  assignable?: boolean
  /** "Perú" (incluye los que no tienen país) | "Ecuador". Solo lo respeta para el admin */
  country?: string
}
